<template>
  <div>
    <div :id="id" class="barchart-style" ref="barchart"></div>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'rgba(88,198,228, 1)'
    },
    id: {
      type: String,
      default: '',
      require: true
    }
  },
  data() {
    return {
      barchart: {}
    }
  },
  mounted() {
    // this.chartInit()
    // window.addEventListener('resize', () => {
    //   this.barchart.dispose()
    //   setTimeout(() => {
    //     this.chartInit()
    //   }, 20)
    // })
  },
  methods: {
    chartInit(itemList, dataList) {
      if (itemList.length < 5) {
        const n = 5 - itemList.length
        for (let index = 0; index < n; index++) {
          itemList.push('')
        }
      }
      this.barchart = this.$echarts.init(document.getElementById(this.id))
      this.barchart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          data: itemList,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            // rotate: 20,
            width: 90, // 将内容的宽度固定
            overflow: 'truncate', // 超出的部分截断
            truncate: '...' // 截断的部分用...代替
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              type: 'dashed'
            }
          }
        },
        dataZoom: {
          show: true,
          start: 0,
          type: 'inside',
          end: (5 / itemList.length) * 100,
          zoomLock: true
        },
        series: [{
          type: 'bar',
          barWidth: '20%',
          barMaxWidth: '30',
          data: dataList,
          itemStyle: {
            color: this.color,
            barBorderRadius: [5, 5, 0, 0]
          }
        }],
        grid: {
          left: '10%',
          top: '10%',
          right: '0%',
          bottom: '10%'
        }
      })
    }
  }
}
</script>
<style>
.barchart-style {
    width:100%;
    height:236px;
}
</style>
